"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const clusterService_1 = require("modules/user/clusterService");
const userInfo_1 = require("modules/user/userInfo");
const useAddSurvicateUserInfo = () => {
    (0, react_1.useEffect)(() => {
        const addUserInfo = async () => {
            var _a, _b;
            const [userProfile, userTypeInfo, cluster] = await Promise.all([
                userInfo_1.userInfoService.getProfile(),
                userInfo_1.userInfoService.getTypeInfo(),
                clusterService_1.clusterService.get()
            ]);
            const survicateData = {
                user_id: userProfile.id,
                language: userProfile.locale,
                country: (_a = userProfile.address) === null || _a === void 0 ? void 0 : _a.country,
                userType: userTypeInfo.userType,
                revenueSegmentation: userTypeInfo.userSegmentationInfo,
                clusterName: cluster.clusterName
            };
            (_b = window === null || window === void 0 ? void 0 : window._sva) === null || _b === void 0 ? void 0 : _b.setVisitorTraits(survicateData);
        };
        addUserInfo();
    }, []);
};
exports.default = useAddSurvicateUserInfo;
